import React, { useCallback, useContext, useState } from 'react'
import { LANGUAGE, LanguageContext } from '../../hocs'
import styles from './LanguageButton.module.css'
import cn from 'classnames'
import { DropdownHeader } from '../DropdownHeader'
import { Icon, IconType } from '../Icon'
import { useOnClickOutside } from '../../hooks/useClickOutside'

type Props = {
  className?: string
  onChangeLanguage: () => void
}

const LANGUAGES = [
  { text: 'Русский', alias: LANGUAGE.RU },
  { text: 'English', alias: LANGUAGE.EN }
]

export const LanguageButton: React.FC<Props> = (props) => {
  const { className, onChangeLanguage } = props
  const { language, changeLanguage } = useContext(LanguageContext)
  const [shouldShowLanguages, setShouldShowLanguages] = useState(false)
  const clickRef = React.useRef<HTMLDivElement>(null)
  useOnClickOutside(clickRef, () => setShouldShowLanguages(false))
  const onClick = useCallback(
    () => setShouldShowLanguages(!shouldShowLanguages),
    [shouldShowLanguages]
  )

  return (
    <div className={cn([styles.root, className])} ref={clickRef}>
      <DropdownHeader
        onClick={onClick}
        className={cn([styles.dropdown])}
        arrowClassName={styles.arrow}
        isActive={shouldShowLanguages}
        shouldShowArrow={false}
      >
        {language === LANGUAGE.RU ? LANGUAGE.RU : LANGUAGE.EN}
      </DropdownHeader>
      {shouldShowLanguages && (
        <div className={styles.languagesWrapper}>
          <div className={styles.languages}>
            <div className={styles.languagesList}>
              {LANGUAGES.map(({ text, alias }) => (
                <div
                  key={alias}
                  className={cn([
                    styles.language,
                    language === alias && styles.active
                  ])}
                  onClick={() => {
                    changeLanguage(alias)
                    setShouldShowLanguages(false)
                    onChangeLanguage()
                  }}
                >
                  <Icon
                    icon={alias.toLowerCase() as IconType}
                    className={styles.icon}
                    collection='language'
                  />
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
